import { render, staticRenderFns } from "./NewOQCSeleItem.vue?vue&type=template&id=029a7aeb&scoped=true"
import script from "./NewOQCSeleItem.vue?vue&type=script&lang=js"
export * from "./NewOQCSeleItem.vue?vue&type=script&lang=js"
import style0 from "./NewOQCSeleItem.vue?vue&type=style&index=0&id=029a7aeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029a7aeb",
  null
  
)

export default component.exports